// extracted by mini-css-extract-plugin
export var image = "SectionTextTextImage-module--image--knSHP";
export var rightSide = "SectionTextTextImage-module--rightSide--pb9DY";
export var section = "SectionTextTextImage-module--section--ZNhip";
export var textOnLeft = "SectionTextTextImage-module--textOnLeft--nYKvN";
export var textOnRight = "SectionTextTextImage-module--textOnRight--JY8fI";
export var textOnRightContent = "SectionTextTextImage-module--textOnRightContent--a1o55";